<template>
    <div class="header">
        <div class="wrapper">
            <div class="logo">
                <a href="/" class="custom-logo-link" rel="home" itemprop="url">
                    <img src="/images/logo.png" alt="DomaGolf SA" itemprop="logo" height="57" width="127">
                </a>
            </div>
            <div class="menu" v-if="!isLoginPage">
              <!--<span v-if="credit" style="margin-right:20px;">You have {{credit}} free hours</span>
              <my-account />-->
                <ul>
                    <li><router-link to="/agenda">Agenda</router-link></li>
                    <li><router-link to="/my-reservations">My reservations</router-link></li>
                    <li><router-link to="/profile">My Account</router-link></li>
                    <li><a href="#" @click.prevent="logout">Logout</a></li>
                    <li><a href="https://domagolf.com">Retour to Domagolf.com</a></li>
                </ul>
            </div>
            <div v-else>
                <ul>
                    <li><a href="https://domagolf.com">Retour to Domagolf.com</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
//import MyAccount from './MyAccount.vue'
export default {
    components:{
        //MyAccount
    },
    computed:{
        ...mapGetters("auth", ["credit"]),
        isLoginPage() {
            return this.$route.path=='/login' || this.$route.path=='/register'
        }
    },
    methods: {
        ...mapActions("auth", { authLogout: "logout" }),
        logout: function() {
            this.authLogout();
            this.$router.go();
        },
    },
}
</script>

<style lang="less">
.header{
    padding: 10px 20px;
    color:white;
    .wrapper{
        display:flex;
        align-items: center;
        justify-content: space-between;
        .logo{
            margin-right: 100px;
        }
        .menu{
            display: flex;
            justify-content: flex-end;
            flex: 1 1 auto;
        }
    }
    ul{
        display: flex;
        width: 100%;
        justify-content: space-between;
        li{
            a,
            button{
                font-size: 1em;
                background-color: transparent;
                color:white;
                text-transform: uppercase;
                &:hover{
                    color:#c9af6b;
                }
            }
        }
    }
}

</style>